import React, { useState, useMemo, useEffect } from 'react';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import StudentDetails from './StudentDetails';
import RefundDetails from './refundDetails/RefundDetails';
import SelectReceipt from './selectReceipt';
import { fetchReceiptsByPaymode, INC_PSID_INC_APPID, OTHERS, studentDetailsLabelFieldMapping, useGetUtils, useSaveDataToConfigValues } from './utils';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { rectRefundStep3InitValues } from '../../config';

const SelectRefundReasonAndReceipt = () => {

    const { values, dropdowns, next, updateValues, current } = useWizard();
    const { selectedStudent, rectRefundStep2Data } = values;

    const [loading, setLoading] = useState(false);
    const [refundDetailsForm, setRefundDetailsForm] = useState(rectRefundStep2Data?.refundDetailsForm);
    const [studentDetailsCorrectionForm, setStudentDetailsCorrectionForm] = useState(rectRefundStep2Data?.studentDetailsCorrectionForm);

    const [receiptsData, setReceiptsData] = useState(rectRefundStep2Data?.receiptsData);
    const [receiptsSelectionModel, setReceiptsSelectionModel] = useState(rectRefundStep2Data?.receiptsSelectionModel);

    const [receiptsFilterForm , setReceiptsFilterForm] = useState(rectRefundStep2Data?.receiptsFilterForm);

    const selectedReceipt = receiptsData?.find(receipt => receipt?.key === receiptsSelectionModel[0]);
    const selectedStudentAppId = selectedStudent?.applicationId;

    const showCorrectStudentDetailsForm = refundDetailsForm?.rectificationReason?.label === INC_PSID_INC_APPID;
    const isOthersReasonSelected = refundDetailsForm?.rectificationReason?.label === OTHERS;


    const paymodeChangeHandler = async (paymode) => {
        try {
            setLoading(true);
            const resp = await fetchReceiptsByPaymode(paymode, selectedStudent, isOthersReasonSelected);
            if (resp?.code === 200) {
                const receipts = resp?.data;
                const updatedReceipts = receipts?.map((receipt, idx) => ({
                    ...receipt,
                    itemTypeList: receipt?.itemTypeList?.map(itemType => ({ label: itemType, value: itemType })),
                    key : `${idx}_${receipt?.receiptId}_${receipt?.paymode}`
                }))
                setReceiptsData(updatedReceipts);
                setRefundDetailsForm(prev => ({ ...prev, paymode }));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const isProceedNextBtnDisabled = () => {

        if(
            !receiptsSelectionModel?.length ||
            showCorrectStudentDetailsForm && Object.keys(studentDetailsCorrectionForm)?.length === 0 ||
            !refundDetailsForm?.rectificationReason ||
            !refundDetailsForm?.attachmentKey

        ) return true;

        return false;

    }

    const proceedNext = () => {
        const currSelectedReceiptId = receiptsSelectionModel[0];
        const oldSelectedReceiptId = rectRefundStep2Data?.receiptsSelectionModel[0];

        if (currSelectedReceiptId !== oldSelectedReceiptId) {
            updateValues("rectRefundStep3Data", rectRefundStep3InitValues);
        }

        isOthersReasonSelected ? next(current + 2) : next();

    }

    const dataToSaveToConfig = {
        refundDetailsForm,
        studentDetailsCorrectionForm,
        receiptsData,
        receiptsSelectionModel,
        selectedReceipt,
        selectedStudentAppId,
        showCorrectStudentDetailsForm,
        receiptsFilterForm
    }

    useSaveDataToConfigValues(dataToSaveToConfig, "rectRefundStep2Data");

    useGetUtils(setLoading);

    const paymentModesDropdown = useMemo(() => {
        const paymentModesDTO = values?.utils?.oldPaymentModesRawObject?.data?.paymentModeMasterDTOList;
        return (paymentModesDTO?.map(mode => ({ ...mode, label: mode?.paymentModeDispValue, value: mode?.id })) ?? [])
    }, [values?.utils])




    return (
        <div className='m-2'>
            {loading && <ALoader position={"fixed"} />}
            <StudentDetails
                studentDetails={selectedStudent}
                // dropdowns={dropdowns?.data}
                labelFieldMappings={studentDetailsLabelFieldMapping(selectedStudent, dropdowns?.data)}
            />

            <RefundDetails
                paymentModesDropdown={paymentModesDropdown}
                refundDetailsForm={refundDetailsForm}
                setRefundDetailsForm={setRefundDetailsForm}
                paymodeChangeHandler={paymodeChangeHandler}
                studentDetailsCorrectionForm={studentDetailsCorrectionForm}
                setStudentDetailsCorrectionForm={setStudentDetailsCorrectionForm}
                setLoading={setLoading}
                showCorrectStudentDetailsForm={showCorrectStudentDetailsForm}
                rectificationRefundReasons={values?.utils?.rectRefundReasons}
                setReceiptsData={setReceiptsData}
            />

            <SelectReceipt
                receiptsData={receiptsData}
                selectionModel={receiptsSelectionModel}
                setSelectionModel={setReceiptsSelectionModel}
                receiptsFilterForm={receiptsFilterForm}
                setReceiptsFilterForm={setReceiptsFilterForm}
            />

            <Footer>
                <div>Select a receipt</div>
                <AButton
                    disabled={isProceedNextBtnDisabled()}
                    onClick={proceedNext}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Proceed next
                </AButton>
            </Footer>
        </div>
    );
}

export default SelectRefundReasonAndReceipt;